import {Menu} from "antd";
import React from "react";


export const DropdownMenu = (props) => {
    const items = props.options.map((option, idx) => {
        return (
            <Menu.Item key={option}>
                {option}
            </Menu.Item>
        )
    });

    return (
        <Menu style={{border: "1px solid lightgray", borderRadius: "3px"}}
              onClick={(e) => props.handleMenuClick(e)}>
            {items}
        </Menu>
    )
}